<template>
  <div class="wrap" :class="{addPadding, questionType}">
    <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
    <CarsForm
        ref="dcDynamicForm"
        :model="model"
        :configData="configData"
        :editStatus="editStatus"
        @submitAction="topicSave"
        @skipTopic="skipTopic"
        @showTopic="showTopic"
        @labelTopic="labelTopic"
        @deleteOption="deleteOption"
        @add-batch="addBatch"
        @handleChange="handleChange"
        @afterRead="afterRead"
        @onOversize="onOversize"
        @deleteOptionImg='deleteOptionImg'
        @addEventListenerForInput="addEventListenerForInput"
        @removeEventListenerForInput="removeEventListenerForInput"
        @setLabelStyle="setLabelStyle"
        @addChildOptions="addChildOptions"
        @openCheckSet="openCheckSet"
    >
    </CarsForm>
    <me-popup v-model="showPop" position="bottom" class="option-setting-popup" @closed="handleCheckSetClosed">
        <div class="option-setting" v-if="checkSetConfig">
            <div class="option-setting__header">
                <div class="option-setting__title">选项设置</div>
                <me-icon name="close" class="option-setting__close" @click="closeCheckSetPop"/>
            </div>
            <div class="option-setting__option-name" v-if="checkSetOptionName">
                {{ checkSetOptionName }}
            </div>
            <div class="option-setting__body">
        <CarsForm
                    ref="checkSetForm"
                    :model="checkSetModel"
                    :configData="checkSetConfig"
                    :editStatus="false"
                />
            </div>
            <div class="option-setting__footer">
                <me-button plain type="default" class="option-setting__btn" @click="closeCheckSetPop">取消</me-button>
                <me-button type="primary" class="option-setting__btn" @click="saveCheckSet">保存</me-button>
            </div>
        </div>
    </me-popup>
  </div>
</template>

<script>
import { Questionnaire } from '@/network'
import CarsForm from 'imc-mobile/src/component/form'
import { mixin } from '@/mixins'
import CarBatchIncrease from 'imc-mobile/src/component/batchIncrease'
import { Toast } from '@guazi-fe/melon'
import { addClass2, removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import debounce from '@/util/debounce'
import { counta } from '@/util/common'
import { getStorage, setStorage } from '@/util/common'

const CarBatchIncreaseMaxRow = 15
// const CarBatchIncreaseCheckBoxMaxRow = 12
const CarBatchIncreaseMaxLength = 50
const OptionMaxRow = 500

export default {
    data() {
        return {
            title: '',
            model: {
                topicName: '',
                paragraph: '',
                required: true, // 默认选中
                leastChoose: '不限制',
                mostChoose: '不限制',
                inputSize: '3',
                batchIncrease: [{
                    value: '',
                    type: 1,
                },
                {
                    value: '',
                    type: 1,
                }],
                skipOption: '',
                showOption: '',
                labelOption: '',
                score: 5,
                label: '',
                labelStyle: '0', // 是否为 标签样式 0 不显示 1 显示
            },
            topicData: {},
            configData: {
                form: {
                    groupData: [{
                        code: 'topicName',
                        label: '题目名称',
                        topicId: '',
                        type: 'textarea',
                        rules: [{ required: true, message: '请填写题目名称' }],
                        props: {
                            maxlength: '300',
                            showWordLimit: true,
                            readonly: this.$route.query.editStatus === '0',
                            rows: "1",
                            noTrim: true,
                            autosize: { maxHeight: 100, minHeight: 30}
                        },
                    }],
                    button: { disabled: false, text: '确定', api: 'button' },
                },
                api: {
                    request: {
                        submit: {
                            url: '',
                            method: 'post',
                        },
                    },
                },
            },
            options: {
                props: { // 表单props配置
                    'validate-first': true,
                    'scroll-to-error': true,
                    'show-error-message': false,
                },
                controls: [],
            },
            scoreUpdate: {},
            isCustomLeft: false,
            addPadding: false,
            editStatus: this.$route.query.editStatus === '0',
            showPop: false,
            checkSetOptionIndex: -1,
            checkSetOptionName: '',
            checkSetModel: {
                enableRemark: false,
                mustFillRemark: false,
                remarkPlaceHolder: '',
                subOptionLeastChoose: '不限制',
                subOptionMostChoose: '不限制',
            },
            checkSetConfig: null,
            checkSetHasChild: false,
            checkSetWatchers: [],
            subOptionChooseColumns: [
                { text: '不限制', value: '不限制' },
                { text: '1项', value: 1 },
                { text: '2项', value: 2 },
                { text: '3项', value: 3 },
                { text: '4项', value: 4 },
                { text: '5项', value: 5 },
                { text: '6项', value: 6 },
                { text: '7项', value: 7 },
                { text: '8项', value: 8 },
                { text: '9项', value: 9 },
                { text: '10项', value: 10 },
                { text: '11项', value: 11 },
                { text: '12项', value: 12 },
                { text: '13项', value: 13 },
                { text: '14项', value: 14 },
                { text: '15项', value: 15 },
            ],
        }
    },
    components: {
        CarsForm,
        CarBatchIncrease,
    },
    mixins: [mixin],
    computed: {
        questionType() {
            console.log('questionType', this.$route.params.type)
            return this.$route.params.type
        },
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
    },
    created() {
        // offStatus('loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        if (this.topicId) {
            this.initData()
        }

        if (this.questionType) {
            if (this.$store.state.model) {
                this.setData()
                return
            }
            addClass2('body', 'loading')
            this.formatInitData()
            this.formatSetData()
            removeClass2('body', 'loading')
        }
    },
    methods: {
        afterRead(file, index) {
            var formData = new FormData()
            formData.append('file', file.file)
            formData.append('tid', this.tid)
            addClass2('body', 'loading')
            Questionnaire.upload(formData, this.tid).then((res) => {
                let { data: { data } } = res
                let obj = this.model.batchIncrease[index]
                obj = {...obj, ...data}
                this.model.batchIncrease.splice(index, 1, obj)
                removeClass2('body', 'loading')
            })
        },
        onOversize() {
            Toast.fail('文件大小不能超过 50M')
        },
        deleteOptionImg(index) {
            this.model.batchIncrease[index].fileId = ''
            this.model.batchIncrease[index].thumbViewUrl = ''
        },
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = true : null
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = false : null
        },
        handleChange(oldValue, value, fn) {
            this.scoreUpdate = { oldValue, value, fn }
            // 标签修改
            const type = this.questionType || this.topicData.topicType
            const labelObj = this.$store.state.labelObj
            if (/^(rate|nps)$/.test(type) && labelObj) {
                this.setLabelObj(labelObj, value)
            }
        },
        setLabelObj(labelObj, value) {
            labelObj.score = value
            this.$store.commit('updateLabelObj', labelObj)
        },
        dealScoreUpdate() {
            return new Promise((resolve) => {
                let { oldValue, value, fn } = this.scoreUpdate
                let { topicType, score } = this.topicData
                if (!/^(rate|matrix-rate)$/.test(topicType) || !value || value / 1 > score / 1) {
                    resolve()
                    return
                }
                // 条件显示引用判断
                const topicsList = getStorage('groupData')
                const currentTopicIndex = topicsList.findIndex(item => item.topicCode === this.topicId)
                let showJson = null
                let str = ''
                let needUpdateTopic = []
                topicsList.forEach((topic, index) => {
                    if (index <= currentTopicIndex || !topic.showJson) return
                    showJson = topic.showJson
                    const relatedTopic = showJson.list && showJson.list.find(item => item.id === this.topicId)
                    if (relatedTopic) {
                        if (relatedTopic.type === 'matrix-rate') {
                            let flag = false
                            relatedTopic.conditions.forEach((condition) => {
                                if (condition.value && condition.value.length) {
                                    flag = condition.value.find(item => item > value)
                                    if (flag) condition.del = true
                                }
                            })
                            if (!flag) return
                        } else {
                            let flag = relatedTopic.conditions.find(condition => condition/1 > value)
                            if (!flag) return
                            relatedTopic.del = true
                        }
                        const label = topic.label
                        const i = label ? /([0-9]*)\./.exec(label)[1] : null
                        str += i ? `第${i}题的显示逻辑依赖于本题；` : '段落的显示逻辑依赖于本题；'
                        needUpdateTopic.push(topic)
                    }
                })
                if (str) {
                    removeClass2('body', 'loading')
                    this.$_dialog({
                        title: '提示',
                        message: `${str}若继续修改，依赖关系将被清空，确定修改吗？`,
                        confirmFn: () => {
                            needUpdateTopic.forEach((topic, index) => {
                                showJson = topic.showJson
                                showJson.list && showJson.list.length && showJson.list.forEach((item, i) => {
                                    if (item.type !== this.topicData.topicType) return
                                    if (item.type === 'matrix-rate') {
                                        item.conditions.forEach((condition, conditionIndex) => {
                                            if (condition.value && condition.value.length) {
                                                condition.value.forEach((conditionItem, index) => {
                                                    conditionItem > value ? condition.value[index] = '' : null
                                                })
                                                condition.value = condition.value.filter(item => item)
                                            }
                                        })
                                        item.conditions.every(item => !item.value || !item.value.length) ? showJson.list.splice(i, 1)  : null
                                    } else {
                                        item.conditions.forEach((condition, index) => {
                                            condition > value ? item.conditions[index] = '' : null
                                        })
                                        item.conditions = item.conditions.filter(item => item)
                                        !item.conditions.length ? showJson.list.splice(i, 1) : null
                                    }
                                })
                                !showJson.list || !showJson.list.length ? topic.showJson = '' : null
                            })
                            needUpdateTopic.forEach((item) => {
                                if (!item.showJson) return
                                let showJson = typeof item.showJson === 'string' ? JSON.parse(item.showJson) : item.showJson
                                showJson = showJson.list && showJson.list.length ? showJson : ''
                                item.showJson = showJson ? JSON.stringify(item.showJson) : ''
                            })
                            const data = {
                                tid: this.tid,
                                pageId: this.pageId,
                                topicList: needUpdateTopic,
                            }
                            // 更新其他题目的条件显示
                            Questionnaire.updateShowJson(data).then((res) => {
                                if (res.data.code === 'S00000') {
                                    resolve()
                                }
                            })
                        },
                        cancelFn: () => {
                            fn(oldValue)
                        }
                    })
                    return
                }
                resolve()
            })
        },
        updateTopic(topicList) {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
                topicList,
            }
            Questionnaire.updateShowJson(data).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        addBatch() {
            if (this.forbiddenEdit()) return
            // 缓存页面数据
            this.cacheData()
            this.$router.push({
                name: 'batch',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                },
            })
        },
        openCheckSet(option, index) {
            if (this.forbiddenEdit()) return
            if (this.model.labelStyle === '1') {
                Toast.fail('标签样式下不可打开选项设置~')
                return
            }
            this.clearCheckSetWatchers()
            const currentOption = this.model.batchIncrease[index] || option || {}
            const hasChild = Array.isArray(currentOption.batchIncrease) && currentOption.batchIncrease.length > 0
            this.checkSetOptionIndex = index
            this.checkSetOptionName = currentOption.value || option.value || ''
            this.checkSetHasChild = hasChild
            this.checkSetModel = {
                enableRemark: hasChild ? false : currentOption.enableRemark === '1',
                mustFillRemark: hasChild ? false : (currentOption.enableRemark === '1' && currentOption.mustFillRemark === '1'),
                remarkPlaceHolder: hasChild ? '' : (currentOption.remarkPlaceHolder || option.remarkPlaceHolder || ''),
                subOptionLeastChoose: hasChild ? (currentOption.subOptionLeastChoose || currentOption.subOptionLeastChoose || '不限制') : '不限制',
                subOptionMostChoose: hasChild ? (currentOption.subOptionMostChoose || currentOption.subOptionMostChoose || '不限制') : '不限制',
            }
            this.buildCheckSetConfig(hasChild)
            this.showPop = true
        },
        closeCheckSetPop() {
            this.showPop = false
            this.resetCheckSetState()
        },
        handleCheckSetClosed() {
            if (!this.showPop) {
                this.resetCheckSetState()
            }
        },
        resetCheckSetState() {
            this.checkSetOptionIndex = -1
            this.checkSetOptionName = ''
            this.checkSetHasChild = false
            this.checkSetConfig = null
            this.clearCheckSetWatchers()
        },
        buildCheckSetConfig(hasChild) {
            const group = {
                type: 'group',
                label: '选项设置',
                code: 'optionSetting',
                items: [],
            }
            if (!hasChild) {
                group.items.push({
                    code: 'enableRemark',
                    label: '启用备注',
                    type: 'switch',
                    value: this.checkSetModel.enableRemark,
                    itemProps: { column: 'horizontal' },
                    listeners: this.createCheckSetListeners('enableRemark'),
                })
                group.items.push({
                    code: 'mustFillRemark',
                    label: '备注必填',
                    type: 'switch',
                    value: this.checkSetModel.mustFillRemark,
                    itemProps: { column: 'horizontal' },
                    listeners: this.createCheckSetListeners('mustFillRemark'),
                })
                group.items.push({
                    code: 'remarkPlaceHolder',
                    label: '备注提示',
                    type: 'text',
                    value: this.checkSetModel.remarkPlaceHolder,
                    placeholder: '请输入备注提示',
                    props: {
                        maxlength: 50,
                    },
                })
            } else {
                const pickerProps = {
                    columns: this.subOptionChooseColumns,
                    rightIcon: 'arrow',
                }
                group.items.push({
                    code: 'subOptionLeastChoose',
                    label: '子选项最少选择',
                    type: 'picker',
                    placeholder: '不限制',
                    value: this.checkSetModel.subOptionLeastChoose,
                    itemProps: { column: 'horizontal' },
                    props: { ...pickerProps },
                    listeners: this.createCheckSetListeners('subOptionLeastChoose'),
                })
                group.items.push({
                    code: 'subOptionMostChoose',
                    label: '子选项最多选择',
                    type: 'picker',
                    placeholder: '不限制',
                    value: this.checkSetModel.subOptionMostChoose,
                    itemProps: { column: 'horizontal' },
                    props: { ...pickerProps },
                    listeners: this.createCheckSetListeners('subOptionMostChoose'),
                })
            }
            this.checkSetConfig = {
                form: {
                    groupData: [group],
                    button: false,
                },
            }
            this.$nextTick(() => this.setupCheckSetWatchers())
        },
        createCheckSetListeners(code) {
            return {
                input: (val) => {
                    this.handleCheckSetFieldChange(code, val)
                },
            }
        },
        handleCheckSetFieldChange(code, value) {
            this.syncCheckSetModelFromTemplate(code, value)
        },
        clearCheckSetWatchers() {
            if (Array.isArray(this.checkSetWatchers) && this.checkSetWatchers.length) {
                this.checkSetWatchers.forEach((unwatch) => {
                    typeof unwatch === 'function' ? unwatch() : null
                })
            }
            this.checkSetWatchers = []
        },
        setupCheckSetWatchers() {
            this.clearCheckSetWatchers()
            this.$nextTick(() => {
                const template = this.getCheckSetTemplate()
                if (!template || !template.itemsMap) return
                const codes = this.checkSetHasChild
                    ? ['subOptionLeastChoose', 'subOptionMostChoose']
                    : ['enableRemark', 'mustFillRemark', 'remarkPlaceHolder']
                codes.forEach((code) => {
                    const item = template.itemsMap[code]
                    if (!item) return
                    const unwatch = this.$watch(
                        () => item.value,
                        (val) => this.syncCheckSetModelFromTemplate(code, val),
                        { immediate: true }
                    )
                    this.checkSetWatchers.push(unwatch)
                })
            })
        },
        getCheckSetTemplate() {
            return this.$refs.checkSetForm.$refs.demoDynamicForm.template || null
        },
        normalizePickerValue(val) {
            if (Array.isArray(val)) {
                const picked = val[0]
                if (picked && picked.value !== undefined) return picked.value
                if (picked !== undefined) return picked
                return '不限制'
            }
            if (val && typeof val === 'object' && val.value !== undefined) {
                return val.value
            }
            if (val === undefined || val === null || val === '') return '不限制'
            return val
        },
        syncCheckSetModelFromTemplate(code, value) {
            if (code === 'enableRemark') {
                const enabled = !!value
                this.$set(this.checkSetModel, code, enabled)
                if (!enabled) {
                    this.$set(this.checkSetModel, 'mustFillRemark', false)
                    this.$set(this.checkSetModel, 'remarkPlaceHolder', '')
                    this.updateCheckSetTemplateValue('mustFillRemark', false)
                    this.updateCheckSetTemplateValue('remarkPlaceHolder', '')
                }
                return
            }
            if (code === 'mustFillRemark') {
                this.$set(this.checkSetModel, code, !!value)
                return
            }
            if (code === 'remarkPlaceHolder') {
                this.$set(this.checkSetModel, code, value || '')
                return
            }
            if (code === 'subOptionLeastChoose' || code === 'subOptionMostChoose') {
                const parsed = this.normalizePickerValue(value)
                this.$set(this.checkSetModel, code, parsed)
            }
        },
        saveCheckSet() {
            this.collectCheckSetValues()
            const index = this.checkSetOptionIndex
            if (index < 0 || !this.model.batchIncrease[index]) {
                this.closeCheckSetPop()
                return
            }
            const option = { ...this.model.batchIncrease[index] }
            if (this.checkSetHasChild) {
                const least = this.normalizeSubOptionValue(this.checkSetModel.subOptionLeastChoose)
                const most = this.normalizeSubOptionValue(this.checkSetModel.subOptionMostChoose)
                this.$set(option, 'subOptionLeastChoose', least)
                this.$set(option, 'subOptionMostChoose', most)
                this.$set(option, 'enableRemark', '0')
                this.$set(option, 'mustFillRemark', '0')
                this.$set(option, 'remarkPlaceHolder', '')
            } else {
                const enableRemarkVal = this.checkSetModel.enableRemark ? '1' : '0'
                const mustFillRemarkVal = this.checkSetModel.enableRemark && this.checkSetModel.mustFillRemark ? '1' : '0'
                const remarkPlaceholderVal = this.checkSetModel.enableRemark ? (this.checkSetModel.remarkPlaceHolder || '') : ''
                this.$set(option, 'enableRemark', enableRemarkVal)
                this.$set(option, 'mustFillRemark', mustFillRemarkVal)
                this.$set(option, 'remarkPlaceHolder', remarkPlaceholderVal)
                this.$set(option, 'subOptionLeastChoose', '不限制')
                this.$set(option, 'subOptionMostChoose', '不限制')
                const childrenData = this.parseChildrenData(option.childrenData) || {}
                childrenData.enableRemark = enableRemarkVal
                childrenData.mustFillRemark = mustFillRemarkVal
                childrenData.remarkPlaceHolder = remarkPlaceholderVal
                option.childrenData = JSON.stringify(childrenData)
            }
            this.$set(this.model.batchIncrease, index, option)
            this.closeCheckSetPop()
        },
        normalizeSubOptionValue(val) {
            if (val === undefined || val === null || val === '' || val === '不限制') {
                return '不限制'
            }
            return val
        },
        collectCheckSetValues() {
            const template = this.getCheckSetTemplate()
            if (!template || !template.itemsMap) return
            const codes = this.checkSetHasChild
                ? ['subOptionLeastChoose', 'subOptionMostChoose']
                : ['enableRemark', 'mustFillRemark', 'remarkPlaceHolder']
            codes.forEach((code) => {
                if (template.itemsMap[code]) {
                    this.syncCheckSetModelFromTemplate(code, template.itemsMap[code].value)
                }
            })
        },
        updateCheckSetTemplateValue(code, value) {
            const template = this.getCheckSetTemplate()
            if (!template || !template.itemsMap || !template.itemsMap[code]) return
            this.$set(template.itemsMap[code], 'value', value)
        },
        formatSubOptionPayload(subList = []) {
            if (!Array.isArray(subList) || !subList.length) return []
            return subList.map((subItem, subIndex) => ({
                itemKey: subItem.type || 'checkbox',
                itemValue: subItem.value,
                itemIndex: subIndex,
            }))
        },
        restoreSubOptionList(subOptionList = []) {
            if (!Array.isArray(subOptionList) || !subOptionList.length) return []
            return subOptionList.map((subItem) => ({
                value: subItem.itemValue || '',
                type: subItem.itemKey || 'checkbox',
                disabled: false,
            }))
        },
        getChildrenDataField(item = {}, key, defaultValue) {
            const childrenData = this.parseChildrenData(item.childrenData)
            if (childrenData && childrenData[key] !== undefined && childrenData[key] !== null) {
                return childrenData[key]
            }
            if (item && item[key] !== undefined && item[key] !== null) {
                return item[key]
            }
            if (key === 'subOptionLeastChoose' && item && item.SubOptionLeastChoose !== undefined) {
                return item.SubOptionLeastChoose
            }
            if (key === 'subOptionMostChoose' && item && item.SubOptionMostChoose !== undefined) {
                return item.SubOptionMostChoose
            }
            return defaultValue
        },
        getSelectItemSubOptions(item = {}) {
            const childrenData = this.parseChildrenData(item.childrenData)
            if (childrenData && Array.isArray(childrenData.subOption)) {
                return childrenData.subOption
            }
            if (Array.isArray(item.subOption)) {
                return item.subOption
            }
            if (Array.isArray(item.SubOption)) {
                return item.SubOption
            }
            return []
        },
        parseChildrenData(data) {
            if (!data) return null
            if (typeof data === 'object') return data
            if (typeof data === 'string') {
                try {
                    return JSON.parse(data)
                } catch (error) {
                    console.warn('parse childrenData error', error)
                    return null
                }
            }
            return null
        },
        buildChildrenDataPayload(option = {}, subOptionPayload = []) {
            return {
                enableRemark: option.enableRemark || '0',
                mustFillRemark: option.mustFillRemark || '0',
                remarkPlaceHolder: option.remarkPlaceHolder || '',
                subOption: subOptionPayload,
                subOptionLeastChoose: option.subOptionLeastChoose || '不限制',
                subOptionMostChoose: option.subOptionMostChoose || '不限制',
            }
        },
        deleteOption(indexOrObj) {
            if (typeof indexOrObj === 'number') {
                const index = indexOrObj
                if (this.model.batchIncrease && Array.isArray(this.model.batchIncrease) && index >= 0 && index < this.model.batchIncrease.length) {
                    this.model.batchIncrease.splice(index, 1)
                }
            const selectItem = this.topicData.selectItem
                if (selectItem && index >= 0 && index < selectItem.length) {
            this.topicData.selectItem.splice(index, 1)
                }
            } else if (typeof indexOrObj === 'object' && indexOrObj !== null) {
                console.log('删除子项:', indexOrObj)
            }
        },
        skipTopic(topic) {
            if (this.forbiddenEdit()) return
            this.cacheData()
            const topicList = JSON.parse(localStorage.getItem('groupData'))
            const index = topicList.findIndex(item => item.code === this.topicData.topicId)
            if (index === topicList.length - 1 || index < 0) {
                Toast.fail('此题为最后一题，不能设置跳题')
                return
            }
            const type = this.questionType || this.topicData.topicType
            const valueIsNot = this.model.batchIncrease.some(item => !item.value)
            if(/^(radio|checkbox|matrix-rate)$/.test(type) && valueIsNot) {
                Toast.fail('选项不能空')
                return
            }
            this.$router.push({
                name: 'skip',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                },
            })
        },
        cacheData() {
            let template = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template
            let model = {}
            Object.entries(template.itemsMap).forEach(([key, { value }]) => {
                model[key] = value
            })
            model.topicType = this.questionType || this.topicData.topicType
            this.$store.commit('updateModel', model)
        },
        addChildOptions(item, index) {
            console.log('addChildOptions', index, item)
            if (this.forbiddenEdit()) return
            let currentBatchIncrease = []
            try {
                const template = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template
                if (template && template.itemsMap && template.itemsMap.batchIncrease) {
                    currentBatchIncrease = template.itemsMap.batchIncrease.value || []
                } else {
                    currentBatchIncrease = this.model.batchIncrease || []
                }
            } catch (e) {
                console.warn('无法从组件中获取 batchIncrease，使用 model.batchIncrease:', e)
                currentBatchIncrease = this.model.batchIncrease || []
            }
            if (!Array.isArray(currentBatchIncrease)) {
                console.error('batchIncrease 不是数组:', currentBatchIncrease)
                return
            }
            const hasOtherOption = currentBatchIncrease.some(option => option.type === 0)
            if (hasOtherOption) {
                Toast.fail('已添加「其他」选项，不能增加子选项~')
                return
            }
            if (this.model.labelStyle === '1') {
                Toast.fail('标签样式下不可增加子选项~')
                return
            }
            if (currentBatchIncrease !== this.model.batchIncrease) {
                this.model.batchIncrease = currentBatchIncrease
            }
            let foundIndex = -1
            if (item) {
                foundIndex = currentBatchIncrease.findIndex(option => option === item)
            }
            if (foundIndex === -1 && item) {
                if (index >= 0 && index < currentBatchIncrease.length) {
                    foundIndex = index
                } else {
                    const matches = []
                    currentBatchIncrease.forEach((option, idx) => {
                        if (option.value === item.value && option.type === item.type) {
                            matches.push(idx)
                        }
                    })
                    if (matches.length > 0) {
                        if (index >= currentBatchIncrease.length) {
                            foundIndex = matches[matches.length - 1]
                        } else if (index < 0) {
                            foundIndex = matches[0]
                        } else {
                            if (matches.length === 1) {
                                foundIndex = matches[0]
                            } else {
                                foundIndex = matches.reduce((prev, curr) => {
                                    return Math.abs(curr - index) < Math.abs(prev - index) ? curr : prev
                                }, matches[0])
                            }
                        }
                    }
                }
            }
            if (foundIndex === -1 && index >= 0 && index < currentBatchIncrease.length) {
                foundIndex = index
            }
            if (foundIndex === -1 || foundIndex < 0 || foundIndex >= currentBatchIncrease.length) {
                console.error(`无法找到对应的选项，index: ${index}, item:`, item, 'currentBatchIncrease:', currentBatchIncrease)
                return
            }

            const currentItem = currentBatchIncrease[foundIndex]
            if (!currentItem) {
                console.error(`索引 ${foundIndex} 对应的项不存在`)
                return
            }
            const remarkEnabled = this.getChildrenDataField(currentItem, 'enableRemark', currentItem.enableRemark || '0') === '1'
            if (remarkEnabled) {
                Toast.fail('已启用备注，不能增加子选项~')
                return
            }
            if (currentItem.enableRemark === '1') {
                currentItem.enableRemark = '0'
                currentItem.mustFillRemark = '0'
                currentItem.remarkPlaceHolder = ''
            }
            if (!currentItem.subOptionLeastChoose) {
                currentItem.subOptionLeastChoose = '不限制'
            }
            if (!currentItem.subOptionMostChoose) {
                currentItem.subOptionMostChoose = '不限制'
            }
            if (!currentItem.batchIncrease || !Array.isArray(currentItem.batchIncrease)) {
                this.$set(currentItem, 'batchIncrease', [])
            }
            currentItem.batchIncrease.push({
                value: '',
                type: 1,
                disabled: false,
            })
            this.$set(currentBatchIncrease, foundIndex, currentItem)
            this.model.batchIncrease = currentBatchIncrease
            console.log('addChildOptions 完成，使用的索引:', foundIndex, '当前 batchIncrease:', this.model.batchIncrease)
        },
        setLabelStyle(item) {
            if (this.forbiddenEdit()) return
            const batchIncrease = this.model.batchIncrease
            const isThumbViewUrl = batchIncrease.some(item => item.thumbViewUrl)
            const isOtherDisabled = batchIncrease.some(item => item.type === 0)
            const hasChildOptions = batchIncrease.some(option => Array.isArray(option.batchIncrease) && option.batchIncrease.length)
            const hasRemark = batchIncrease.some(option => {
                if (option.enableRemark === '1') {
                    return true
                }
                const childrenData = this.parseChildrenData(option.childrenData)
                if (childrenData && childrenData.enableRemark === '1') {
                    return true
                }
                return false
            })
            if (isThumbViewUrl) {
                Toast.fail('选项设置图片后不可设置为标签样式~')
                this.$set(item, 'value', '0')
                return false
            } else if (isOtherDisabled) {
                Toast.fail('选项添加了其他后不可设置为标签样式~')
                this.$set(item, 'value', '0')
                return false
            } else if (hasChildOptions) {
                Toast.fail('存在子选项，不能设置为标签样式~')
                this.$set(item, 'value', '0')
                return false
            } else if (hasRemark) {
                Toast.fail('存在备注，不能设置为标签样式~')
                this.$set(item, 'value', '0')
                return false
            } else {
                // 先同步表单数据到 model，确保获取最新的题目名称
                const dcDynamicForm = this.$refs.dcDynamicForm
                const demoDynamicForm = dcDynamicForm && dcDynamicForm.$refs && dcDynamicForm.$refs.demoDynamicForm
                const template = demoDynamicForm && demoDynamicForm.template
                if (template && template.itemsMap && template.itemsMap.topicName) {
                    // 同步表单中的最新值到 model
                    this.model.topicName = template.itemsMap.topicName.value || ''
                }
                const savedTopicName = this.model.topicName || ''
                // 更新 labelStyle 和 optionImg
                this.model.labelStyle = this.model.labelStyle === '1' ? '0' : '1'
                this.configData.form.groupData.forEach((itemRes) => {
                    if (itemRes.code === 'batchIncrease') {
                        this.$set(itemRes.props, 'optionImg', this.model.labelStyle === '0')
                    }
                })
                // 在下一个 tick 中恢复题目名称
                this.$nextTick(() => {
                    const newDcDynamicForm = this.$refs.dcDynamicForm
                    const newDemoDynamicForm = newDcDynamicForm && newDcDynamicForm.$refs && newDcDynamicForm.$refs.demoDynamicForm
                    const newTemplate = newDemoDynamicForm && newDemoDynamicForm.template
                    if (newTemplate && newTemplate.itemsMap && newTemplate.itemsMap.topicName && savedTopicName) {
                        this.$set(newTemplate.itemsMap.topicName, 'value', savedTopicName)
                    }
                    if (this.model.topicName !== savedTopicName && savedTopicName) {
                        this.model.topicName = savedTopicName
                    }
                })
            }
        },
        showTopic() {
            if (this.forbiddenEdit()) return
            // 缓存页面数据
            this.cacheData()
            const topicList = JSON.parse(localStorage.getItem('groupData'))
            const index = topicList.findIndex(item => item.code === this.topicData.topicId)
            if (index === 0 || !topicList.length) {
                Toast.fail('此题为第一题，不能设置显示条件')
                return
            }
            const hasCondition = topicList.slice(0, index === -1 ? topicList.length : index).some(topic => !/^paragraph|text|textarea$/.test(topic.type))
            if (!hasCondition) {
                Toast.fail('此题前面没有单选、多选、评分、矩阵评分、NPS题，无法设置显示条件')
                return
            }
            // 显示条件中显示的题目
            this.$store.commit('updateTopicName', '')
            let topicName = ''
            let itemsMap = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template.itemsMap
            topicName = (this.topicData.topicType || this.questionType) === 'paragraph' ? itemsMap['paragraph'].value : itemsMap['topicName'].value
            this.$store.commit('updateTopicName', topicName)

            this.$router.push({
                name: 'show',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                    type: this.topicId ? this.topicData.topicType : this.questionType,
                },
            })
        },
        labelTopic() {
            if (this.forbiddenEdit()) return
            // 缓存页面数据
            this.cacheData()
            let { scoreUpdate: { value }, model: { score }, $store: { state: { labelObj } } } = this
            const { labelJson, labelOption, extJson } = this.topicData || {}
            let ext = {}
            if (extJson) {
                try {
                    ext = typeof extJson === 'string' ? JSON.parse(extJson) : (extJson || {})
                } catch (e) { ext = {} }
            }
            const { labelRequired, labelValid } = ext
            const requiredCount = (Array.isArray(labelValid) ? labelValid : []).reduce((acc, item) => {
                if (item && item.score != null) {
                    acc[item.score] = {
                        minCount: (item.minCount != null ? item.minCount : 1),
                        maxCount: (item.maxCount != null ? item.maxCount : 20),
                    }
                }
                return acc
            }, {})
            labelObj ? null : this.$store.commit('updateLabelObj', {
                score: value ? value : score,
                labelJson: labelJson ? JSON.parse(labelJson) : null,
                labelOption: labelOption || '',
                labelRequired: labelRequired != null && labelRequired !== undefined ? !!labelRequired : true,
                requiredCount,
            })
            this.$router.push({
                name: 'label',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                    type: this.topicId ? this.topicData.topicType : this.questionType,
                },
            })
        },
        forbiddenEdit() {
            let flag = false
            if (this.editStatus) {
                Toast.fail('本问卷已有人作答、不允许操作')
                flag = true
            }
            return flag
        },
        formatInitData() {
            if (this.questionType == 'textarea') {
                this.title = '填空'
            } else if (this.questionType == 'paragraph') {
                this.title = '段落说明'
                this.configData.form.groupData = [{
                    code: 'paragraph',
                    label: '段落描述内容',
                    type: 'textarea',
                    props: {
                        // rows: isAndroid ? 7 : 10,
                        rows: 10,
                        maxlength: '1000',
                        showWordLimit: true,
                    },
                    placeholder: '',
                    rules: [{ required: true, message: '段落描述内容不能为空' }],
                }]
            } else if (this.questionType == 'rate') {
                this.title = '评分'
            } else if (this.questionType == 'nps') {
                this.title = 'NPS量表'
            }else if (this.questionType == 'matrix-rate') {
                this.title = '矩阵评分'
                this.model.batchIncrease = [
                    {
                        disabled:false,
                        type:1,
                        value:"选项1",

                    },
                    {
                        disabled:false,
                        type:2,
                        value:"选项2",

                    }
                ]
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '行标题',
                    code: 'group2',
                    items: [],
                })
                this.configData.form.groupData.push({
                    code: 'batchIncrease',
                    label: '(位于矩阵左侧)',
                    type: 'batchIncrease',
                    component: CarBatchIncrease,
                    other: 'hide',
                    rules: [
                        { required: true, message: '请先输入选项' },
                        {
                            required: true,
                            message: `最多输入${CarBatchIncreaseMaxLength}个字`,
                            validator: (val) => {
                                if (val.length > CarBatchIncreaseMaxLength) {
                                    return false
                                }
                                return true

                            },
                        }],
                    props: {
                        maxRow: CarBatchIncreaseMaxRow,
                        optionImg: false,
                    },
                })
            } else {
                const defaultIconList = this.questionType === 'checkbox' ? [
                    {
                        url: 'https://image-pub.guazistatic.com/qnbdp1066x07c11420d6634d62ac34cb3d1d5880271763105728.png',
                        title: '打开设置页面',
                        event: 'openCheckSet',
                        type: 'img',
                    },
                    {
                        url: 'https://image-pub.guazistatic.com/qnbdp1066xee0ee7e2e7df4dccb14663e1e5c60d901763105725.png',
                        title: '增加子选项',
                        event: 'addChildOptions',
                        type: 'img',
                    },
                ] : []
                this.configData.form.groupData.push({
                    code: 'batchIncrease',
                    label: '选项',
                    type: 'batchIncrease',
                    component: CarBatchIncrease,
                    rules: [
                        { required: true, message: '请先输入选项' },
                        {
                            required: true,
                            message: `最多输入${CarBatchIncreaseMaxLength}个字`,
                            validator: (val) => {
                                if (typeof val === 'string' && val.length > CarBatchIncreaseMaxLength) {
                                    return false
                                }
                                return true

                            },
                        }],
                    props: {
                        // maxRow: this.questionType === 'radio' ? CarBatchIncreaseMaxRow : CarBatchIncreaseCheckBoxMaxRow,
                        maxRow: OptionMaxRow,
                        optionImg: true,
                        iconList: defaultIconList,
                        //  maxlength: CarBatchIncreaseMaxLength,

                    },
                })
                if (this.questionType == 'radio') {
                    this.title = '单选'
                } else {
                    this.title = '多选'
                }

            }
        },
        formatSetData(questionType) {
            // 根据题型设置
            questionType = questionType || this.questionType
            const setShow = {
                code: 'showOption',
                label: '显示条件',
                type: 'picker',
                placeholder: '未设置',
                props: {
                    readonly: true,
                    columns: [{
                        'text': '已设置',
                        'value': '1',
                    },{
                        'text': '未设置',
                        'value': '0',
                    },],
                    rightIcon: 'arrow',
                },
                itemProps: {
                    column: 'horizontal',
                },
            }
            const setSkip = {
                code: 'skipOption',
                label: '设置跳题',
                type: 'picker',
                placeholder: '未设置',
                props: {
                    readonly: true,
                    columns: [{
                        'text': '已设置',
                        'value': '1',
                    },{
                        'text': '未设置',
                        'value': '0',
                    },],
                    rightIcon: 'arrow',
                },
                itemProps: {
                    column: 'horizontal',
                },
            }
            const setLabel = {
                code: 'labelOption',
                label: '标签',
                type: 'picker',
                placeholder: '未设置',
                props: {
                    readonly: true,
                    columns: [{
                        'text': '已设置',
                        'value': '1',
                    },{
                        'text': '未设置',
                        'value': '0',
                    },],
                    rightIcon: 'arrow',
                },
                itemProps: {
                    column: 'horizontal',
                },
            }
            const setIdentification = {
                code: 'label',
                label: '题目标识',
                type: 'text',
                placeholder: '请输入',
                props: {
                    readonly: this.editStatus,
                    maxlength: 50,

                },
                itemProps: {
                    column: 'horizontal',
                },
            }
            if (questionType == 'textarea') {
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '设置',
                    code: 'group2',
                    items: [{
                        code: 'required',
                        label: '此题必答',
                        type: 'switch',
                        itemProps: {
                            column: 'horizontal',
                        },
                        props: {
                            disabled: this.editStatus,
                        }
                        // },{
                        //     code: "contentValid",
                        //     label: "内容限制",
                        //     type: "picker",
                        //     props:{
                        //         columns: [{
                        //             "text":"不限",
                        //             "value":'不限'
                        //         },{
                        //             "text":"整数",
                        //             "value":'整数'
                        //         },{
                        //             "text":"小数",
                        //             "value":'小数'
                        //         },{
                        //             "text":"手机号",
                        //             "value":'手机号'
                        //         },{
                        //             "text":"邮箱",
                        //             "value":'邮箱'
                        //         },{
                        //             "text":"身份证号",
                        //             "value":'身份证号'
                        //         }],
                        //     },
                        //     itemProps:{
                        //         column:'horizontal',
                        //     }
                    }, {
                        code: 'inputSize',
                        label: '输入框大小',
                        type: 'picker',
                        placeholder: '3行',
                        props: {
                            readonly: this.editStatus,
                            columns: [{
                                'text': '1行',
                                'value': '1',
                            }, {
                                'text': '2行',
                                'value': '2',
                            }, {
                                'text': '3行',
                                'value': '3',
                            }, {
                                'text': '4行',
                                'value': '4',
                            }, {
                                'text': '5行/不限答题字数',
                                'value': '5',
                            }],
                            rightIcon: 'arrow',
                        },
                        itemProps: {
                            column: 'horizontal',
                        },
                    },
                    setShow,
                    setSkip,
                    setIdentification,],
                })
            } else if (questionType == 'paragraph') {
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '设置',
                    code: 'group2',
                    items: [setShow, setIdentification]
                })
            } else if (questionType === 'rate') {
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '设置',
                    code: 'group2',
                    items: [
                        {
                            code: 'required',
                            label: '此题必答',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                disabled: this.editStatus,
                            }
                        },
                        {
                            code: 'score',
                            label: '分数设置',
                            type: 'picker',
                            placeholder: '5',
                            props: {
                                readonly: this.editStatus,
                                columns: [{
                                    'text': '2',
                                    'value': '2',
                                }, {
                                    'text': '3',
                                    'value': '3',
                                }, {
                                    'text': '4',
                                    'value': '4',
                                }, {
                                    'text': '5',
                                    'value': '5',
                                }, {
                                    'text': '6',
                                    'value': '6',
                                }, {
                                    'text': '7',
                                    'value': '7',
                                }, {
                                    'text': '8',
                                    'value': '8',
                                }, {
                                    'text': '9',
                                    'value': '9',
                                }, {
                                    'text': '10',
                                    'value': '10',
                                }],
                                rightIcon: 'arrow',
                            },
                            itemProps: {
                                column: 'horizontal',
                            },
                        },
                        setLabel,
                        setShow,
                        setSkip,
                        setIdentification,
                    ],
                })
            } else if (questionType === 'matrix-rate') {
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '列显示',
                    code: 'group2',
                    items: [
                        {
                            code: 'score',
                            label: '分数',
                            type: 'picker',
                            placeholder: '5',
                            props: {
                                readonly: this.editStatus,
                                columns: [{
                                    'text': '2',
                                    'value': '2',
                                }, {
                                    'text': '3',
                                    'value': '3',
                                }, {
                                    'text': '4',
                                    'value': '4',
                                }, {
                                    'text': '5',
                                    'value': '5',
                                }, {
                                    'text': '6',
                                    'value': '6',
                                }, {
                                    'text': '7',
                                    'value': '7',
                                }, {
                                    'text': '8',
                                    'value': '8',
                                }, {
                                    'text': '9',
                                    'value': '9',
                                }, {
                                    'text': '10',
                                    'value': '10',
                                }],
                                rightIcon: 'arrow',
                            },
                            itemProps: {
                                column: 'horizontal',
                            },
                        },
                    ],
                })
                this.configData.form.groupData.push({
                    type: 'group', // 分组
                    label: '设置',
                    code: 'group2',
                    items: [
                        {
                            code: 'required',
                            label: '此题必答',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                disabled: this.editStatus,
                            }
                        },
                        setShow,
                        setSkip,
                        setIdentification,
                    ],
                })
            } else {
                if (questionType == 'radio' || questionType === 'nps') {
                    let items = questionType === 'nps' ? [
                        {
                            code: 'required',
                            label: '此题必答',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                disabled: this.editStatus,
                            }
                        },
                        setLabel,
                        setShow,
                        setSkip,
                        setIdentification,
                    ] : [
                        {
                            code: 'required',
                            label: '此题必答',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                disabled: this.editStatus,
                            }
                        },
                        setShow,
                        setSkip,
                        setIdentification,
                    ]
                    this.configData.form.groupData.push({
                        type: 'group', // 分组
                        label: '设置',
                        code: 'group2',
                        items,
                    })
                } else {
                    this.configData.form.groupData.push({
                        type: 'group', // 分组
                        label: '设置',
                        code: 'group2',
                        items: [{
                            code: 'required',
                            label: '此题必答',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                disabled: this.editStatus,
                            }
                        }, {
                            code: 'leastChoose',
                            label: '最少选择',
                            type: 'picker',
                            placeholder: '不限制',
                            props: {
                                readonly: this.editStatus,
                                columns: [{
                                    'text': '不限制',
                                    'value': '不限制',
                                }, {
                                    'text': '1项',
                                    'value': 1,
                                }, {
                                    'text': '2项',
                                    'value': 2,
                                }, {
                                    'text': '3项',
                                    'value': 3,
                                }, {
                                    'text': '4项',
                                    'value': 4,
                                }, {
                                    'text': '5项',
                                    'value': 5,
                                }, {
                                    'text': '6项',
                                    'value': 6,
                                }, {
                                    'text': '7项',
                                    'value': 7,
                                }, {
                                    'text': '8项',
                                    'value': 8,
                                }, {
                                    'text': '9项',
                                    'value': 9,
                                }, {
                                    'text': '10项',
                                    'value': 10,
                                }, {
                                    'text': '11项',
                                    'value': 11,
                                }, {
                                    'text': '12项',
                                    'value': 12,
                                }, {
                                    'text': '13项',
                                    'value': 13,
                                }, {
                                    'text': '14项',
                                    'value': 14,
                                }, {
                                    'text': '15项',
                                    'value': 15,
                                }],
                                rightIcon: 'arrow',
                            },
                            itemProps: {
                                column: 'horizontal',
                            },
                        }, {
                            code: 'mostChoose',
                            label: '最多选择',
                            type: 'picker',
                            placeholder: '不限制',
                            props: {
                                readonly: this.editStatus,
                                columns: [{
                                    'text': '不限制',
                                    'value': '不限制',
                                }, {
                                    'text': '1项',
                                    'value': 1,
                                }, {
                                    'text': '2项',
                                    'value': 2,
                                }, {
                                    'text': '3项',
                                    'value': 3,
                                }, {
                                    'text': '4项',
                                    'value': 4,
                                }, {
                                    'text': '5项',
                                    'value': 5,
                                }, {
                                    'text': '6项',
                                    'value': 6,
                                }, {
                                    'text': '7项',
                                    'value': 7,
                                }, {
                                    'text': '8项',
                                    'value': 8,
                                }, {
                                    'text': '9项',
                                    'value': 9,
                                }, {
                                    'text': '10项',
                                    'value': 10,
                                }, {
                                    'text': '11项',
                                    'value': 11,
                                }, {
                                    'text': '12项',
                                    'value': 12,
                                }, {
                                    'text': '13项',
                                    'value': 13,
                                }, {
                                    'text': '14项',
                                    'value': 14,
                                }, {
                                    'text': '15项',
                                    'value': 15,
                                }],
                                rightIcon: 'arrow',
                            },
                            itemProps: {
                                column: 'horizontal',
                            },
                        },
                        setShow,
                        setSkip,
                        {
                            code: 'labelStyle',
                            label: '设置为标签样式',
                            type: 'switch',
                            itemProps: {
                                column: 'horizontal',
                            },
                            props: {
                                'active-value': '1',
                                'inactive-value': '0',
                            },
                        },
                        setIdentification,],
                    })
                }
            }
            if (/^(radio|checkbox|matrix-rate)$/.test(questionType) && getStorage('options-true') === 1 ) {
                const options = getStorage('options') || []
                this.model.batchIncrease = options.map((item) => ({
                    value: item.dicValue,
                    type: item.itemIndex == 10000 ? 0 : 1, // 0 其他 1 选项
                    disabled: false,
                }))
                setStorage('options-true', 0)
            }
            const { showConfirm, labelObj } = this.$store.state
            const showOption = this.$store.state.showJson ? '1' : '0'
            showConfirm ? this.model.showOption = showOption : null
            this.model.labelOption = labelObj ? labelObj.labelOption : '0'
        },
        setBatchOption(item) {
            let { topicType } = item
            let isRadioOrCheckbox = /^(radio|checkbox)$/.test(topicType)
            const buildOptionModel = (option, index) => {
                const enableRemark = this.getChildrenDataField(option, 'enableRemark', '0')
                const mustFillRemark = this.getChildrenDataField(option, 'mustFillRemark', '0')
                const remarkPlaceHolder = this.getChildrenDataField(option, 'remarkPlaceHolder', '')
                const subOptionLeastChoose = this.getChildrenDataField(option, 'subOptionLeastChoose', '不限制')
                const subOptionMostChoose = this.getChildrenDataField(option, 'subOptionMostChoose', '不限制')
                const subOptionSource = Array.isArray(option.batchIncrease) && option.batchIncrease.length
                    ? option.batchIncrease
                    : this.restoreSubOptionList(this.getSelectItemSubOptions(option))
                return {
                    value: option.itemKey !== undefined ? option.itemKey : option.dicValue,
                    type: option.type === undefined ? (option.itemIndex == 10000 ? 0 : 1) : option.type,
                    disabled: false,
                    enableRemark,
                    mustFillRemark,
                    remarkPlaceHolder,
                    subOptionLeastChoose,
                    subOptionMostChoose,
                    batchIncrease: subOptionSource,
                    fileId: isRadioOrCheckbox ? (option.fileId || (item.batchIncrease && item.batchIncrease[index] ? item.batchIncrease[index].fileId : '')) : '',
                    thumbViewUrl: isRadioOrCheckbox ? (option.thumbViewUrl || (item.batchIncrease && item.batchIncrease[index] ? item.batchIncrease[index].thumbViewUrl : '')) : '',
                }
            }
            if ( getStorage('options-true') === 1 ) {
                const options = getStorage('options') || []
                this.model.batchIncrease = options.map((option, index) => buildOptionModel(option, index))
                setStorage('options-true', 0)
            } else {
                this.model.batchIncrease = (item.selectItem || []).map((option, index) => buildOptionModel(option, index))
            }
        },
        initData() {
            addClass2('body', 'loading')
            const data = {
                tid: this.tid,
                // pageId: this.pageId,
                topicId: this.topicId,
            }
            Questionnaire.topicInfo(data)
                .then((res) => {
                    removeClass2('body', 'loading')
                    const { code, data } = res.data
                    this.topicData = data[0]
                    if (code == 'S00000') {
                        this.setData(data)
                    } else {
                        throw new Error(res.data.message)
                    }
                })
                .catch((error) => {
                    removeClass2('body', 'loading')
                    console.log(error.response)
                    Toast.fail(error.response.data.message)
                })
        },
        setData(data = [{}]) {
            // 缓存页面数据
            let model = this.$store.state.model
            if (model) {
                this.topicData = { ...this.topicData, ...model }
                data[0] = { ...data[0], ...model }
                if (model.batchIncrease) {
                    let selectItem = data[0].selectItem ? JSON.parse(JSON.stringify(data[0].selectItem)) : []
                    let itemObj = {}
                    let newItem = {}
                    data[0].selectItem = []
                    model.batchIncrease.forEach((item, index) => {
                        itemObj = selectItem[index] || {}
                        const subOptionPayload = this.formatSubOptionPayload(item.batchIncrease)
                        const childrenData = this.buildChildrenDataPayload(item, subOptionPayload)
                        newItem = {
                            itemIndex: item.type === 0 ? '10000' : String(index),
                            itemKey: item.value,
                            itemValue: String(index),
                            type: item.type,
                            childrenData,
                            downloadUrl: item.downloadUrl,
                            fileId: item.fileId,
                            thumbDownloadUrl: item.thumbDownloadUrl,
                            thumbViewUrl: item.thumbViewUrl,
                            viewUrl: item.viewUrl,
                        }
                        data[0].selectItem.push({...itemObj, ...newItem})
                    })
                }
                this.$store.commit('updateModel', null)
            }
            this.configData.form.groupData[0].topicId = this.topicId
            const formatData = data && data.map((item) => {
                let topicItem = []
                switch (item.topicType) {
                    case 'radio':
                    case 'checkbox':
                        topicItem = {
                            code: 'batchIncrease',
                            label: '选项',
                            type: 'batchIncrease',
                            component: CarBatchIncrease,
                            rules: [
                                { required: true, message: '请先输入选项' },
                                {
                                    required: true,
                                    message: `最多输入${CarBatchIncreaseMaxLength}个字`,
                                    validator: (val) => {
                                        if (typeof val === 'string' && val.length > CarBatchIncreaseMaxLength) {
                                            return false
                                        }
                                        return true
                                    },
                                }],
                            props: {
                                // maxRow: this.topicData.topicType === 'radio' ? CarBatchIncreaseMaxRow : CarBatchIncreaseCheckBoxMaxRow,
                                maxRow: OptionMaxRow,
                                optionImg: true,
                                //  maxlength: CarBatchIncreaseMaxLength,
                            },
                        }
                        this.setBatchOption(item)
                        this.title = item.topicType == 'radio' ? '单选' : '多选'
                        break
                    case 'textarea':
                        this.title = '填空'
                        break
                    case 'paragraph':
                        topicItem = {
                            code: 'commonNote',
                            label: '段落描述内容',
                            placeholder: '',
                            props: {
                                rows: 10,
                                maxlength: '1000',
                                showWordLimit: true,
                            },
                            type: 'textarea',
                            rules: [{ required: true, message: '请填写段落描述内容' }],
                            value: '',
                        }

                        this.title = '段落说明'
                        break
                    case 'rate':
                        this.title = '评分'
                        break
                    case 'nps':
                        this.title = 'NPS量表'
                        break
                    case 'matrix-rate':
                        this.title = '矩阵评分'
                        this.setBatchOption(item)
                        break
                }
                if (item.topicType == 'textarea') {
                    this.model.inputSize = item.inputSize
                } else if (item.topicType == 'paragraph') {
                    this.configData.form.groupData = [{
                        code: 'paragraph',
                        label: '段落描述内容',
                        type: 'textarea',
                        placeholder: '请填段落描述内容',
                        rules: [{ required: true, message: '段落描述内容不能为空' }],
                        props: {
                            rows: 10,
                            maxlength: '1000',
                            showWordLimit: true,
                            readonly: this.editStatus,
                        },
                    }]
                    this.model.paragraph = model ? model.paragraph : item.commonNote
                } else if (/^(rate|nps)$/.test(item.topicType)) {
                } else if (/matrix-rate/.test(item.topicType)) {
                    this.configData.form.groupData.push({
                        type: 'group', // 分组
                        label: '行标题',
                        code: 'group2',
                        items: [],
                    })
                    this.configData.form.groupData.push({
                        code: 'batchIncrease',
                        label: '(位于矩阵左侧)',
                        type: 'batchIncrease',
                        component: CarBatchIncrease,
                        other: 'hide',
                        rules: [
                            { required: true, message: '请先输入选项' },
                            {
                                required: true,
                                message: `最多输入${CarBatchIncreaseMaxLength}个字`,
                                validator: (val) => {
                                    if (val.length > CarBatchIncreaseMaxLength) {
                                        return false
                                    }
                                    return true

                                },
                            }],
                        props: {
                            maxRow: CarBatchIncreaseMaxRow,
                            disabled: this.editStatus,
                            optionImg: false,
                            //  maxlength: CarBatchIncreaseMaxLength,
                        },
                    },)
                } else {
                    this.configData.form.groupData.push({
                        code: 'batchIncrease',
                        label: '选项',
                        type: 'batchIncrease',
                        component: CarBatchIncrease,
                        rules: [
                            { required: true, message: '请先输入选项' },
                            {
                                required: true,
                                message: `最多输入${CarBatchIncreaseMaxLength}个字`,
                                validator: (val) => {
                                    if (typeof val === 'string' && val.length > CarBatchIncreaseMaxLength) {
                                        return false
                                    }
                                    return true
                                },
                            }],
                        props: {
                            // maxRow: this.topicData.topicType === 'radio' ? CarBatchIncreaseMaxRow : CarBatchIncreaseCheckBoxMaxRow,
                            maxRow: OptionMaxRow,
                            disabled: this.editStatus,
                            iconList: /checkbox/.test(item.topicType) ?[
                                {
                                    url: 'https://image-pub.guazistatic.com/qnbdp1066x07c11420d6634d62ac34cb3d1d5880271763105728.png',
                                    title: '打开设置页面',
                                    event: 'openCheckSet',
                                    type: 'img',
                                },
                                {
                                    url: 'https://image-pub.guazistatic.com/qnbdp1066xee0ee7e2e7df4dccb14663e1e5c60d901763105725.png',
                                    title: '增加子选项',
                                    event: 'addChildOptions',
                                    type: 'img',
                                }
                            ] : [],
                            optionImg: this.topicData.labelStyle === '0',
                            //  maxlength: CarBatchIncreaseMaxLength,
                        },
                    })
                }
                this.model.topicName = item.topicName
            })
            formatData[0] ? this.configData.form.groupData.push(formatData) : null
            this.formatSetData(this.topicData.topicType)
            this.model.required = this.topicData.required
            this.model.leastChoose = this.topicData.leastChoose
            this.model.mostChoose = this.topicData.mostChoose
            this.model.score = this.topicData.score
            this.model.label = this.topicData.label
            this.model.labelStyle = this.topicData.labelStyle

            let { skipObj, showJson, showConfirm, labelObj } = this.$store.state
            // 显示
            const showOption = showJson ? '1' : '0'
            this.model.showOption = showConfirm ? showOption : this.topicData.showOption
            // 跳题
            this.model.skipOption = this.topicData.skipOption
            if (skipObj) {
                let { skipOption } = skipObj
                this.model.skipOption = !!skipOption
            }
            // 标签
            this.model.labelOption = labelObj ? labelObj.labelOption : this.topicData.labelOption
        },
        topicSave: debounce(function (res) {
            let types = []
            let { type } = this.$route.params
            let groupData = JSON.parse(localStorage.getItem('groupData'))
            groupData.forEach((obj) => {
                types.push(obj.type)
            })
            types.push(type)
            let num = counta(types)
            if (num > 15900) {
                Toast.fail('保存失败，数目超过最大限制')
                return
            }
            // if (/多选/.test(this.title) && this.model.batchIncrease && this.model.batchIncrease.length > 15) {
            //     Toast.fail('已经超过您设置的最大数量，不能再添加啦~')
            //     return
            // }
            // if (/单选/.test(this.title) && this.model.batchIncrease && this.model.batchIncrease.length > 15) {
            //     Toast.fail('已经超过您设置的最大数量，不能再添加啦~')
            //     return
            // }
            addClass2('body', 'loading')
            // 后端需要默认字段
            const topicInfo = {
                'topicCode': this.topicData.topicCode || '',
                'topicName': res.topicName,
                'topicType': this.questionType,
                'required': !!res.required,
                'selectItem': '[]',
                'commonNote': '',
                'leastChoose': '不限制',
                'mostChoose': '不限制',
                'inputSize': '3',
                'topicValue': '',
                'otherValue': '',
                'score': '5',
                'contentValid': '',
                'skipOption': !!res.required ? '1' : '0',
                'skipJson': '',
                'displayCondition': '',
                'sortNo': '',
                'label': res.label,
                'labelStyle': res.labelStyle,
            }
            // 批量组件 单选/多选
            let validFailed = false
            let { skipObj } = this.$store.state
            // let isRadioOrCheckbox = /多选|单选/.test(this.title)
            if (res.batchIncrease && res.batchIncrease.length) {
                let selectItem = []
                let topicData = this.topicData
                let hasItem = false
                res.batchIncrease.map((item, index) => {
                    // 10000 表示其他
                    hasItem = topicData && topicData.selectItem && topicData.selectItem[index]
                    if (item.value == '') {
                        validFailed = true
                    }
                    const selectItemItem = {
                        itemKey: item.value,
                        itemValue: index,
                        itemIndex: item.type == 0 ? '10000' : index,
                        // itemUrl: '',
                        skipTarget: hasItem ? topicData.selectItem[index].skipTarget : '',
                        fileId: item.fileId,
                        // thumbViewUrl: isRadioOrCheckbox ? item.thumbViewUrl : '',
                    }
                    const subOptions = this.formatSubOptionPayload(item.batchIncrease)
                    selectItemItem.childrenData = this.buildChildrenDataPayload(item, subOptions)
                    selectItem.push(selectItemItem)
                })
                if (skipObj) {
                    let mergeSelect = []
                    let batchSelect = {}
                    res.batchIncrease.forEach((item, index) => {
                        const subOptions = this.formatSubOptionPayload(item.batchIncrease)
                        batchSelect = {
                            itemKey: item.value,
                            itemIndex: item.type == 0 ? '10000' : index,
                            itemValue: index,
                            fileId: item.fileId,
                            thumbViewUrl: item.thumbViewUrl,
                        }
                        batchSelect.childrenData = this.buildChildrenDataPayload(item, subOptions)
                        const merged = { ...(skipObj.selectItems[index] || {}), ...batchSelect }
                        delete merged.enableRemark
                        delete merged.mustFillRemark
                        delete merged.remarkPlaceHolder
                        delete merged.subOption
                        delete merged.subOptionLeastChoose
                        delete merged.subOptionMostChoose
                        mergeSelect.push(merged)
                    })
                    skipObj.selectItems = mergeSelect.map((n) => {
                        delete n.imgUrl
                        delete n.thumbViewUrl
                        delete n.itemUrl
                        return n
                    })
                }
                topicInfo.selectItem = skipObj ? JSON.stringify(skipObj.selectItems) : JSON.stringify(selectItem)
            }
            // 段落描述
            if (res.paragraph) {
                topicInfo.commonNote = res.paragraph
            }

            if (res.leastChoose) {
                topicInfo.leastChoose = res.leastChoose
            }

            if (res.mostChoose) {
                topicInfo.mostChoose = res.mostChoose
            }
            if (res.inputSize) {
                topicInfo.inputSize = res.inputSize
            }
            if (res.score) {
                topicInfo.score = res.score
            }
            const selectItemLength = this.topicData && this.topicData.selectItem ? this.topicData.selectItem.length : 0
            if (skipObj && skipObj.skipJson) {
                topicInfo.skipJson = skipObj.skipJson ? JSON.stringify(skipObj.skipJson) : ''
            } else {
                let { skipTarget, skipValue } = this.topicData.skipJson || {}
                if (skipValue === '1') {
                    let score = res.score / 1
                    const hasSkipRule = selectItemLength && score < selectItemLength ? this.topicData.selectItem.slice(0, selectItemLength-score).some(topic => topic.skipTarget) : this.topicData.selectItem.some(topic => topic.skipTarget)
                    topicInfo.skipJson = hasSkipRule ? JSON.stringify({ skipTarget, skipValue }) : ''
                } else {
                    topicInfo.skipJson = this.topicData.skipJson ? JSON.stringify(this.topicData.skipJson) : ''
                }
            }
            topicInfo.skipOption = topicInfo.skipJson ? topicInfo.skipOption : ''
            if (validFailed) {
                removeClass2('body', 'loading')
                Toast.fail('输入项不能为空')
                return
            }
            // 初始化评分/NPS量表的selectItem
            // 新增
            if (/^(评分|NPS量表)$/.test(this.title) && (!this.topicData.selectItem || !this.topicData.selectItem.length)) {
                topicInfo.selectItem = []
                const isRate = this.title === '评分'
                const end = isRate ? topicInfo.score : 11
                let obj = {}
                for (let i=0; i<end; i++) {
                    obj = isRate ? { itemKey: i + 1, itemIndex: i, itemValue: i + 1 } : { itemKey: i, itemIndex: i, itemValue: i }
                    topicInfo.selectItem.push(obj)
                }
                topicInfo.selectItem = JSON.stringify(topicInfo.selectItem)
            }
            // 编辑
            let skipObjSelect = skipObj && skipObj.selectItems ? skipObj.selectItems : null
            if (this.topicData.selectItem && this.topicData.selectItem.length && this.title === 'NPS量表') {
                topicInfo.selectItem = skipObjSelect ? JSON.stringify(skipObjSelect) : JSON.stringify(this.topicData.selectItem)
            }
            if (this.topicData.selectItem && this.topicData.selectItem.length && this.title === '评分') {
                if (selectItemLength < topicInfo.score) {
                    const diff = topicInfo.score - selectItemLength
                    let obj = {}
                    for (let i = 0; i < diff; i++) {
                        obj = { itemKey: i + 1 + selectItemLength, itemIndex: i + selectItemLength, itemValue: i + 1 + selectItemLength }
                        this.topicData.selectItem.push(obj)
                    }
                    topicInfo.selectItem = skipObjSelect ? JSON.stringify(skipObjSelect) : JSON.stringify(this.topicData.selectItem)
                } else {
                    topicInfo.selectItem = skipObjSelect ? JSON.stringify(skipObjSelect) : JSON.stringify(this.topicData.selectItem.slice(0, topicInfo.score))
                }
            }
            console.log('topicInfo', topicInfo)
            this.dealScoreUpdate().then(() => {
                Questionnaire.topicSave({
                    tid: this.tid,
                    pageId: this.pageId,
                    ...topicInfo,
                }).then((res) => {
                    removeClass2('body', 'loading')
                    if (res.data.code == 'S00000') {
                        const topicCode = res.data.data.topicCode
                        this.saveShowJson(topicCode)
                    }
                }).catch((error) => {
                    console.log(error.response)
                    removeClass2('body', 'loading')
                    Toast.fail(error.response.data.message)
                })
            })
        }, 800),
        // 保存显示条件/标签单独抽出来
        saveShowJson(topicCode) {
            let { showConfirm, showJson, labelObj } = this.$store.state
            const saveData = {
                tid: this.tid,
                pageId: this.pageId,
                topicCode,
                showJson: showConfirm ? showJson : this.topicData.showJson || '',
                labelJson: labelObj && labelObj.labelJson && Object.values(labelObj.labelJson).some(item => item) ? JSON.stringify(labelObj.labelJson) : (this.topicData ? this.topicData.labelJson : ''),
            }
            if (labelObj) {
                const rc = labelObj.requiredCount && typeof labelObj.requiredCount === 'object' ? labelObj.requiredCount : {}
                const labelValid = Object.entries(rc).map(([score, v]) => ({
                    score: String(score),
                    minCount: (v.minCount != null ? v.minCount : 1),
                    maxCount: (v.maxCount != null ? v.maxCount : 20),
                }))
                saveData.extJson = JSON.stringify({
                    labelRequired: labelObj.labelRequired || false,
                    labelValid,
                })
            } else if (this.topicData && this.topicData.extJson) {
                saveData.extJson = typeof this.topicData.extJson === 'string' ? this.topicData.extJson : JSON.stringify(this.topicData.extJson)
            }
            Questionnaire.saveShowJson(saveData).then((res) => {
                removeClass2('body', 'loading')
                if (res.data.code == 'S00000') {
                    this.$store.commit('updateShowJson', '')
                    this.$store.commit('updateLabelObj', null)
                    this.$store.commit('updateShowConfirm', false)
                    this.$store.commit('updateShowTopicList', null)
                    this.$store.commit('updateSkipObj', null)
                    this.$router.replace({
                        name: 'edit',
                        params: {
                            pageId: this.pageId,
                        },
                        query: {
                            scroll: this.$route.query.scroll || 'add'
                        }
                    })
                }
            }).catch((error) => {
                console.log(error.response)
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .addPadding {
        padding-bottom: 400PX!important;
    }
    .wrap{
        position: relative;
        height: 100%;
        &.paragraph {
            padding-bottom: 150px;
        }
    }
    ::v-deep .option-setting-popup {
        .option-setting {
            background: #fff;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            padding: 20px 24px 24px;
            .me-field__body {
                width: 100%;
            }
        }
        .option-setting__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 8px;
        }
        .option-setting__close {
            font-size: 18px;
        }
        .option-setting__option-name {
            font-size: 14px;
            color: #969799;
            margin-bottom: 12px;
        }
        .option-setting__body {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
        .option-setting__row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;
            font-size: 14px;
        }
        .option-setting__footer {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 16px;
        }
        .option-setting__btn {
            width: 120px;
        }
    }

    ::v-deep .form_submit{
        left: 0;
        position: fixed;
        width: 100%;
        bottom: 0;
    }
    ::v-deep .dynamic-form-container {
        .me-form {
            .me-field__control[name=topicName]{
                background: #F6F6F6;
                height: 38px;
                border-radius: 6px;
            }
            // .add-other-bg {
            //     background: #F6F6F6;
            //     border-radius: 5px;
            // }
            .me-field__body {
                textarea {
                    &[name=paragraph]{
                        height: calc(100vh - 260px);
                    }
                    background: #F6F6F6!important;
                    line-height: 36px;
                    border-radius: 6px;
                    padding-left: 16px ;
                }
            }
            .car-batch-increase{
                .me-cell{
                    display: flex;
                    flex-direction: row;
                    .me-field__body {
                        textarea {
                            background: #F6F6F6!important;
                            line-height: 36px;
                            border-radius: 6px;
                            padding-left: 16px ;
                        }
                        .me-field__control--custom{
                            justify-content: flex-end;
                        }
                    }
                }
            }
        }
        .me-field__control_gray {
            .me-field__control{
                color: #bec5cf;
            }
        }
        .me-form-group{
            background: transparent;
            .me-form-group-head {
                padding: 0;
                .me-form-group-head__title {
                    height: 43px;
                    line-height: 43px;
                    // background: #F2F4F6;
                }
            }
            .dynamic-form-fielditem {

                .me-field__label{
                    // padding: 12px 0;
                    margin-bottom: 0;
                }

                .me-field__value{
                    display: flex;
                    justify-content: flex-end;
                }
                .me-cell{
                    padding: 0 22px;
                    line-height: 52px;
                    .me-field__body {
                        textarea {
                            background: #F6F6F6!important;
                            line-height: 36px;
                            border-radius: 6px;
                            padding-left: 16px ;
                        }
                        .me-field__control--custom{
                            justify-content: flex-end;
                        }
                    }
                }
            }
        }
        // 修复：选项下线
        .car-batch-increase .me-cell {
            &::after{
                right:0;
            }
        }

        .me-switch--on{
            background: #06B455;
        }
        .dynamic-form-footer{
            .me-button--primary{
                background: #06B455;
            }
        }
    }
    ::v-deep .me-cell--clickable:active{
        background-color: #fff;
    }
    ::v-deep .dynamic-form-container .me-form .me-field__body textarea[name=topicName] {
        max-height: 700px;
        padding: 10px  0.42667rem;
        line-height: normal;
    }
    #app.android .wrap {
        &.paragraph {
            ::v-deep .dynamic-form-container .me-form .me-field__body textarea[name=paragraph] {
                height: calc(100vh - 360px);
            }
        }
    }
</style>
